import moment from "moment/moment";

// функция "компенсации" разницы во времени между часовым поясом в конфигах и часовым поясом машины клиента
export const fixTimezoneDiff = (date: Date): any => {
  const offset1 = moment(date).utcOffset();
  const offset2 = 0 - date.getTimezoneOffset();
  return moment(date).add(offset2 - offset1, 'minutes').valueOf();
};
